import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=06204cfc"
import script from "./Cashback.vue?vue&type=script&lang=js"
export * from "./Cashback.vue?vue&type=script&lang=js"
import style0 from "./cashback-tema.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports